import type { Variants } from "motion/react";
import { useAnimation } from "motion/react";
import * as m from "motion/react-m";
import { forwardRef, useImperativeHandle } from "react";

import { cn } from "@/shared/lib";
import type { AnimatedIconProps } from "@/shared/ui/animated-icon";

export interface BellIconHandle {
  startAnimation: () => void;
  stopAnimation: () => void;
}

const SVG_VARIANTS: Variants = {
  normal: { rotate: 0 },
  animate: { rotate: [0, -10, 10, -10, 0] },
};

const BellIcon = forwardRef<BellIconHandle, AnimatedIconProps>(
  ({ className, size = 24, ...props }, ref) => {
    const controls = useAnimation();
    useImperativeHandle(ref, () => {
      return {
        startAnimation: () => controls.start("animate"),
        stopAnimation: () => controls.start("normal"),
      };
    });

    return (
      <m.svg
        className={cn("lucide", className)}
        {...props}
        animate={controls}
        fill="none"
        height={size}
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        transition={{
          duration: 0.5,
          ease: "easeInOut",
        }}
        variants={SVG_VARIANTS}
        viewBox="0 0 24 24"
        width={size}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
        <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
      </m.svg>
    );
  }
);

BellIcon.displayName = "BellIcon";

export { BellIcon };
